export const GET_PLAYER_BY_TEAM_REQUEST = "GET_PLAYER_BY_TEAM_REQUEST";
export const GET_PLAYER_BY_TEAM_SUCCESS = "GET_PLAYER_BY_TEAM_SUCCESS";
export const GET_PLAYER_BY_TEAM_FAILURE = "GET_PLAYER_BY_TEAM_FAILURE";


export const GET_ALL_SPORTS_TEAMS_REQUEST = "GET_ALL_SPORTS_TEAMS_REQUEST";
export const GET_ALL_SPORTS_TEAMS_SUCCESS = "GET_ALL_SPORTS_TEAMS_SUCCESS";
export const GET_ALL_SPORTS_TEAMS_FAILURE = "GET_ALL_SPORTS_TEAMS_FAILURE";
